(function () {
  'use strict';
  function initialize(root) {
    root.querySelectorAll('[data-xr-fixed-sets]').forEach(sets => {
      if (sets.dataset.initialized) return;
      const section = sets.closest('.product-section');
      const form = document.getElementById(sets.dataset.formId);
      if (!section || !form) return;
      sets.dataset.initialized = 'true';
      const panel = section.querySelector('[data-xr-dumbbell-racks]');
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:sets.dataset.currency || 'CAD',currencyDisplay:'narrowSymbol'});
      const property = document.createElement('input');
      property.type = 'hidden'; property.name = 'properties[Set contents]'; form.appendChild(property);
      function update() {
        const option = sets.querySelector('[data-xr-fixed-option]:checked');
        if (!option) return;
        const pairs = Number(option.dataset.pairs);
        const weights = Array.from({length:pairs},(_,i)=>(i+1)*5);
        const contents = '5–' + option.dataset.end + ' lb · ' + pairs + ' pairs (' + pairs*2 + ' dumbbells); one pair each of ' + weights.join(', ') + ' lb';
        sets.querySelector('[data-xr-set-contents]').textContent = contents;
        property.value = contents;
        if (panel) {
          const rack = Array.from(panel.querySelectorAll('[data-xr-addon]')).find(row=>row.querySelector('[data-xr-addon-check]').checked);
          const rackPrice = rack ? Number(rack.querySelector('[data-xr-addon-variant]').dataset.price) : 0;
          panel.querySelector('[data-xr-configured-total]').textContent = money.format((Number(option.dataset.price)+rackPrice)/100);
          const warning = panel.querySelector('[data-xr-rack-capacity]');
          warning.hidden = !rack;
          const capacity = rack && Number(rack.dataset.capacity);
          warning.textContent = !rack ? '' : pairs > capacity ? 'Your set includes ' + pairs + ' pairs. This rack holds up to ' + capacity + ' pairs, so the full set needs additional storage.' : 'Capacity: up to ' + capacity + ' pairs.';
        }
        section.dispatchEvent(new CustomEvent('xr:configurationChange'));
      }
      sets.addEventListener('change',update);
      if (panel) panel.addEventListener('change',update);
      form.addEventListener('submit',event=>{
        const option = sets.querySelector('[data-xr-fixed-option]:checked');
        const master = form.querySelector('[name=id]');
        if (!option || option.dataset.available !== 'true' || !master || master.value !== option.dataset.variantId) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      },true);
      update();
      window.addEventListener('load',update,{once:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('quickview:loaded',()=>initialize(document));
})();
